import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import InfiniteLoading from "vue-infinite-loading";
import ApiService from "@/services/api-service";
import VModal from "vue-js-modal";
import Notifications from "vue-notification";
import NProgress from "nprogress";
import loader from "./loader";

Vue.use(VModal, {
  dialog: true,
  dynamic: true
});

import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import sv from "vee-validate/dist/locale/sv.json";

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
localize("sv", sv);
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

Vue.use(Notifications);
Vue.use(NProgress);

ApiService.init();
Vue.use(InfiniteLoading, {
  slots: {
    // keep default styles
    noResults: "ingen data",
    noMore: "all data laddad"
  }
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
